import { css } from '@/styled-system/css';

export const headerNavMdAndUpCX = css({
  display: { base: 'none', md: 'block' },
});

export const headerNavMdAndUpHeaderNavCX = css({
  width: '100%',
  height: 'desktopHeaderHeight',
  marginTop: 0,
  marginBottom: 0,
  paddingTop: '0px',
  paddingRight: '8px',
  paddingBottom: '0px',
  paddingLeft: '48px',
  boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.1), inset 0 0px 0 0 #f2f2f2',
  display: 'flex',
  alignItems: 'center',
});

export const headerNavMdAndUpNavListCX = css({
  display: 'flex',
  alignItems: 'center',
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

export const headerNavMdAndUpLgAndUpCX = css({
  display: { base: 'none', lg: 'inline-block' },
  verticalAlign: { lg: 'bottom' },
});

export const headerNavMdAndUpMenuIconCX = css({
  backgroundColor: 'hpxWhite',
  float: 'left',
  padding: 0,
  color: 'hpxGrey500',
  cursor: 'pointer',
  position: 'absolute',
  display: 'block',
  top: '10px',
  marginTop: '0px',
  width: '30px',
  height: '30px',
  left: '16px',
});

export const headerNavMdAndUpMenuIconSpanCX = css({
  position: 'absolute',
  width: '16px',
  height: '0px',
  top: 0,
  boxShadow: '0 10px 0 1px #949494, 0 16px 0 1px #949494, 0 22px 0 1px #949494',
  display: 'block',
});

export const headerNavMdAndUpLogoWrapperCX = css({
  display: 'inline-block',
  marginRight: '16px',
  verticalAlign: 'text-bottom',
  width: '110px',
  position: 'relative',
  top: '-4px',
});

export const headerNavMdAndUpLogoCX = css({
  width: '100%',
  verticalAlign: 'middle',
  height: '29px',
});
